let mutations = {
    setHappynewyear2018(state, data) {
        state.uploadimg = data;
    },
    setNewyear2018Bless(state, data) {
        state.bless = data;
    },
    setNewyear2018MergeImg(state, data) {
        state.mergeimg = data;
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/happyNewYear2018/mutations.js